import { useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import {
	AutocompleteInput,
	ReferenceInput,
	SelectInput,
	TextInput,
} from "react-admin";
import SubmitFilters from "../components/filters/SubmitFilters";
import { usersConfig } from "../users";
import statuses from "./statuses";

const getYears = () => {
	let years = [];
	const currentYear = new Date().getFullYear();
	for (let year = currentYear; year > currentYear - 7; year--) {
		// Anno in cui è stato implementato
		// sto benedetto sostituto d'imposta.
		if (year > 2019) {
			years.push({
				id: year,
				name: year,
			});
		}
	}
	return years;
};

const Filters = ({ isAdmin, ...props }) => {
	const theme = useTheme();
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	return (
		<SubmitFilters {...props}>
			<SelectInput
				source="target_year"
				choices={getYears()}
				style={{ minWidth: 180 }}
				allowEmpty
				emptyText="ra.action.all"
			>
				<TextInput />
			</SelectInput>
			{isAdmin && (
				<ReferenceInput
					source="user_id"
					reference="users"
					alwaysOn={!sm}
					fullWidth
					style={{ marginTop: theme.spacing(4) }}
					{...usersConfig.reference}
				>
					<AutocompleteInput optionText="name" />
				</ReferenceInput>
			)}
			<SelectInput
				source="status"
				choices={statuses}
				optionText="name"
				alwaysOn
				resettable
				fullWidth
				allowEmpty
				emptyText="ra.action.all"
			/>
		</SubmitFilters>
	);
};
export default Filters;
